import {Component, Input, OnInit} from '@angular/core';
import { Router} from "@angular/router";
import {ShipmentService} from "../../../../../../open-api-generated/services/shipment.service";
import {ShipmentInternalInfo} from "../../../../../../open-api-generated/models/shipment-internal-info";
import {ToastsService} from "../../../../../../services/toasts.service";

declare var UIkit: any;

@Component({
  selector: 'app-shipment-internal-info-card',
  templateUrl: './shipment-internal-info-card.component.html',
  styleUrls: ['./shipment-internal-info-card.component.scss']
})
export class ShipmentInternalInfoCardComponent implements OnInit {
  @Input('shipmentId') shipmentId: number = null;
  @Input('internalNumber') public internalNumber: string = null;

  shipmentInternalInfo: ShipmentInternalInfo = null;

  constructor(
    private router: Router,
    private toastsService: ToastsService,
    private shipmentService: ShipmentService,
  ) {
  }

  hasNotResolvedNotRegisteredProblem: boolean = false;

  ngOnInit(): void {
    this.shipmentService.appV2ShipmentGetInternalInfo({internalNumber: this.internalNumber}).subscribe(
      (shipmentResponse: any) => {
        this.shipmentInternalInfo = shipmentResponse.data;
        for (let problem of this.shipmentInternalInfo.problems) {
          if ('SHIPMENT_REGISTRATION_FAILED' === problem.rule.code && 'reported' === problem.status) {
            this.hasNotResolvedNotRegisteredProblem = true;
            break;
          }
        }
      }
    );
  }

  activePayload: string = null;

  openPayloadModal(payload: string): void {
    if (null === payload) {
      return;
    }

    this.activePayload = atob(payload);
    UIkit.modal('#problemPayloadModal').show();

    document.querySelector('#payloadQuote').innerHTML = atob(payload)
      .replace(/\n( *)/g, function (match, p1) {
        return '<br>' + '&nbsp;'.repeat(p1.length);
      });
  }

  reTryRegister(): void {
    this.shipmentService.appV2ShipmentReTryRegister({
      body: {
        id: this.shipmentId,
      }
    }).subscribe(
      (): void => {
        this.toastsService.showMessage('Pomyślnie zarejestrowano przesyłkę u kuriera zewnętrznego!', 's');
        this.router.navigateByUrl('/shipment/' + this.internalNumber);
      },
      (): void => {
        this.toastsService.showMessage('Nie udało się zarejestrować przesyłki u kuriera zewnętrzengo', 'e');
      },
    )
  }

  protected readonly JSON = JSON;
}
